import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { oauthHref } from '@/lib/auth-api';

interface ProviderButtonProps {
  disabled?: boolean;
  className?: string;
}

function navigateToProvider(provider: 'google' | 'apple') {
  window.location.href = oauthHref(provider);
}

export function GoogleAuthButton({ disabled, className }: ProviderButtonProps) {
  const { t } = useTranslation();
  const [busy, setBusy] = useState(false);
  return (
    <button
      type="button"
      disabled={disabled || busy}
      onClick={() => {
        setBusy(true);
        navigateToProvider('google');
      }}
      className={`inline-flex h-11 items-center justify-center gap-2 rounded-xl border border-ink-200 bg-white px-4 text-sm font-semibold text-ink-900 hover:bg-ink-100 active:scale-[0.98] disabled:opacity-50 disabled:pointer-events-none transition ${className || ''}`}
    >
      <GoogleIcon className="h-4 w-4" />
      {t('auth.continue_with_google')}
    </button>
  );
}

export function AppleAuthButton({ disabled, className }: ProviderButtonProps) {
  const { t } = useTranslation();
  const [busy, setBusy] = useState(false);
  return (
    <button
      type="button"
      disabled={disabled || busy}
      onClick={() => {
        setBusy(true);
        navigateToProvider('apple');
      }}
      className={`inline-flex h-11 items-center justify-center gap-2 rounded-xl bg-black text-white px-4 text-sm font-semibold hover:bg-neutral-800 active:scale-[0.98] disabled:opacity-50 disabled:pointer-events-none transition ${className || ''}`}
    >
      <AppleIcon className="h-4 w-4" />
      {t('auth.continue_with_apple')}
    </button>
  );
}

function GoogleIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 48 48" className={className} aria-hidden>
      <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.6-6 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.1 7.9 3l5.7-5.7C34.6 5.8 29.6 4 24 4 13 4 4 13 4 24s9 20 20 20 20-9 20-20c0-1.3-.1-2.3-.4-3.5z" />
      <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 16 19 13 24 13c3.1 0 5.8 1.1 7.9 3l5.7-5.7C34.6 5.8 29.6 4 24 4 16.3 4 9.5 8.4 6.3 14.7z" />
      <path fill="#4CAF50" d="M24 44c5.4 0 10.4-2.1 14.1-5.4l-6.5-5.5c-2.1 1.4-4.7 2.3-7.6 2.3-5.2 0-9.7-3.3-11.3-8l-6.5 5C9.3 39.5 16.1 44 24 44z" />
      <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.3 4.3-4.3 5.7l6.5 5.5C42 35.5 44 30.1 44 24c0-1.3-.1-2.3-.4-3.5z" />
    </svg>
  );
}

function AppleIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden>
      <path d="M16.4 1.5c0 1.1-.4 2.1-1.2 3-.8.9-1.9 1.4-2.9 1.3-.1-1.1.4-2.2 1.2-3 .9-.9 2-1.4 2.9-1.3zM20 17.3c-.6 1.3-.8 1.9-1.6 3-1.1 1.6-2.7 3.7-4.6 3.7-1.7 0-2.2-1.1-4.5-1.1-2.3 0-2.8 1.1-4.5 1.1-1.9 0-3.4-1.8-4.6-3.4-3.1-4.4-3.4-9.6-1.5-12.4 1.3-2 3.4-3.2 5.4-3.2 2 0 3.3 1.1 4.9 1.1 1.6 0 2.6-1.1 4.9-1.1 1.8 0 3.7 1 5 2.7-4.4 2.4-3.7 8.7.1 9.6z" />
    </svg>
  );
}
